import { type StatsigLayerName, useLayer } from '@coursera-web/statsig';

const LAYER_NAME: StatsigLayerName = 's12n-free-trial-removal-india-layer';
const PARAM_NAME = 'remove-s12n-free-trial';

/**
 * True when the user is bucketed into the India free-trial-removal treatment arm.
 *
 * Reading the layer logs the Statsig exposure, so calling this hook wherever the treatment is
 * consumed (enroll CTA, enroll modal) doubles as the impression — no separate logging step.
 * `useLayer` itself is always called to satisfy the Rules of Hooks, but `.get()` -- the call
 * that actually logs the exposure -- is skipped for learners who can't enroll through an s12n
 * subscription, since they'd never see the treatment difference and would otherwise inflate the
 * exposed population (e.g. every standalone-course enroll button render).
 */
export const useFreeTrialRemovalTreatment = (canSubscribeToS12n: boolean): boolean => {
  const layer = useLayer(LAYER_NAME);
  return canSubscribeToS12n ? layer.get(PARAM_NAME, false) : false;
};
